import React, { useState, useContext } from 'react';

import { DataContext as personContext } from '../../../stores/crm-person-store.js';
import { DataContext as dealContext } from '../../../stores/crm-deal-store.js';
import { DataContext as organizationContext } from '../../../stores/crm-organization-store.js';
import { DataContext as activityContext } from '../../../stores/crm-activity-store.js';
import { DataContext as insightsContext } from '../../../stores/crm-insights-store.js';

import OnHoverTooltip from '../../tables/shared/OnHoverTooltip';
import ReactLoading from 'react-loading';

import { GetExcel } from '../requests/CommonRequests';

const ExportCrmToExcel = (crmPage) => {
    const [isLoading, setIsLoading] = useState(false);

    const page = crmPage.crmPage;

    let context = null;
    let excelName = 'Export';

    switch (page) {
        case 'CrmDeals':
            context = dealContext;
            excelName = 'Affärer';
            break;
        case 'CrmAvailableConsultants':
            context = dealContext;
            excelName = 'Tillgängliga-Konsulter';
            break;
        case 'CrmOrganizations':
            context = organizationContext;
            excelName = 'Organisationer';
            break;
        case 'CrmPersons':
            context = personContext;
            excelName = 'Personer';
            break;
        case 'CrmActivities':
            context = activityContext;
            excelName = 'Aktiviteter';
            break;
        case 'CrmInsights':
            context = insightsContext;
            excelName = 'Uppföljande';
            break;
        default:
            context = dealContext;
            break;
    }

    const {
        store: { apiUrl, requestObject, currentPipelineId, pipelines },
    } = useContext(context);

    const getExcel = () => {
        if (!isLoading) {
            setIsLoading(true);

            if (pipelines && pipelines[currentPipelineId] && context === dealContext) {
                GetExcel(apiUrl, pipelines[currentPipelineId].requestObject, excelName, retreivedExcel);
            } else if (requestObject) {
                GetExcel(apiUrl, requestObject, excelName, retreivedExcel);
            } else{
                // not implemented or supported
                setIsLoading(false);
            }
        }
    };

    const retreivedExcel = () => {
        setIsLoading(false);
    };

    const canDownloadToExcel = requestObject || (pipelines && pipelines[currentPipelineId] && context === dealContext);
    if (!canDownloadToExcel)
    {
        return "";
    }

    return (
        <>
            <OnHoverTooltip labelClassNames='d-flex my-auto' dataFor='excel-dl' showText={null} tooltipType='dark' tooltipPlace='left'>
                <button type='button' className='btn btn-outline-secondary border-0 dropdown d-flex my-auto' onClick={getExcel}>
                    {isLoading ? <ExcelLoading /> : <span className='oi oi-data-transfer-download'></span>}
                </button>
                <span>Exporterar vald data till en Excel-fil</span>
            </OnHoverTooltip>
        </>
    );
};

export default ExportCrmToExcel;

const ExcelLoading = () => {
    return (
        <div className='d-flex justify-content-center w-100'>
            <ReactLoading type={'bars'} color={'#262f3d'} height={27} width={18} />
        </div>
    );
};
